export enum EngineReportType {
  MainEngine = 'ME',
  PrimeMover = 'PM',
  AuxiliaryEngine = 'AE',
}
